module.exports = __webpack_public_path__ + "images/2-en.jpg?v=17b9e4e76a851899fab5b6ab9416f9ae";